import React, { useState } from 'react'
import PropTypes from 'prop-types'
import DataTabs from '@codecraftkit/data-tabs'
import { cn, warnRemovedProps } from '@codecraftkit/theme'
import { ProfilePictureChooseAvatar } from './../ProfilePictureChooseAvatar'
import { ProfilePictureUploadImage } from './../ProfilePictureUploadImage'
import { useGetUserPermissionToUploadImage } from './../../hooks/useGetUserPermissionToUploadImage'
import { useGetAvatarDefaultImages } from './../../hooks/useGetAvatarDefaultImages'

export const ProfileChangeImage = (
  {
    className,
    // Chakra style-props object for the wrapper.
    styles,
    item,
    callback,
    onCloseModal,
    closeModalOnSubmit,
    type = 'default',
    addTabs = [],
    getUserPermissionToUploadImage,
    isUploadImageEnabled = true,
    isChooseAvatarEnabled = true,
    checkForAgencyToChooseAvatar,
    avatarImageGroupKey,
    chooseAvatarAction,
    avatarsData = [],
    getImage,
    loading,
    isRounded,
    disableAgencyIcon,
    imagesGap,
    ...rest
  }) => {
  //Upload Image Props
  const uploadImageProps = {
    imageField: rest?.imageField,
    defaultImage: rest?.defaultImage,
    uploadImageAction: rest?.uploadImageAction,
    getImage: getImage,
    aspect: rest?.aspect
  }
  warnRemovedProps('ProfileImage', { styles }, { styles: 'className' })

  const [userAllowToUploadImage] = useGetUserPermissionToUploadImage(item, getUserPermissionToUploadImage)
  const [avatars, getImageLoading] = avatarImageGroupKey ? useGetAvatarDefaultImages({
    item,
    key: avatarImageGroupKey,
    skip: type !== 'upload' && !isChooseAvatarEnabled,
    checkForAgencyToChooseAvatar
  }) : [avatarsData, false]
  const [index, setIndex] = useState(0)

  const data = [
    {
      name: 'chooseAvatar',
      label: 'Choose Avatar',
      isEnabled: isChooseAvatarEnabled,
      content: <ProfilePictureChooseAvatar
        item={item}
        avatars={avatars}
        callback={callback}
        chooseAvatarAction={chooseAvatarAction}
        getImageLoading={loading || getImageLoading}
        getImage={getImage}
        onCloseModal={onCloseModal}
        closeModalOnSubmit={closeModalOnSubmit}
        isRounded={isRounded}
        disableAgencyIcon={disableAgencyIcon}
        imagesGap={imagesGap}
      />
    },
    {
      name: 'upload',
      label: 'Upload image',
      isEnabled: isUploadImageEnabled && userAllowToUploadImage,
      content: <ProfilePictureUploadImage
        item={item}
        callback={callback}
        onCloseModal={onCloseModal}
        closeModalOnSubmit={closeModalOnSubmit}
        isRounded={isRounded}
        {...uploadImageProps}
      />
    },
    ...addTabs
  ].filter(tab => tab?.isEnabled ?? true)

  /*
   * `type` picks ONE tab and renders it without the tab strip. If the name does not match any
   * tab it falls back to the strip, which is what the original's `??` chain did — written as an
   * early return because a nested ternary that repeats its own else-branch is hard to read and
   * was, in fact, duplicated verbatim.
   */
  const tabs = <DataTabs data={data} tabIndex={index} setTabIndex={setIndex} />
  const single = type !== 'default' ? data.find(tab => tab?.name === type)?.content : undefined

  return <div className={cn(className)}>{single ?? tabs}</div>
}

ProfileChangeImage.propTypes = {
  item: PropTypes.object,
  callback: PropTypes.func,
  onCloseModal: PropTypes.func,
  closeModalOnSubmit: PropTypes.bool,
  /** `'default'` shows the tab strip; any tab name renders that one alone. */
  type: PropTypes.string,
  addTabs: PropTypes.array,
  getUserPermissionToUploadImage: PropTypes.func,
  isUploadImageEnabled: PropTypes.bool,
  isChooseAvatarEnabled: PropTypes.bool,
  checkForAgencyToChooseAvatar: PropTypes.bool,
  avatarImageGroupKey: PropTypes.string,
  chooseAvatarAction: PropTypes.func,
  avatarsData: PropTypes.array,
  getImage: PropTypes.func,
  loading: PropTypes.bool,
  isRounded: PropTypes.bool,
  disableAgencyIcon: PropTypes.bool,
  imagesGap: PropTypes.string,
  className: PropTypes.string
}
